import { render, staticRenderFns } from "./GoodsDrafts.vue?vue&type=template&id=57a90aba"
import script from "./GoodsDrafts.vue?vue&type=script&lang=js"
export * from "./GoodsDrafts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports